"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectPwhCListLength = exports.selectLastFlushing = exports.selectFilteredIdList = exports.selectDevicesDataByPwhC = exports.selectDevicesById = exports.selectDeviceValuesById = exports.selectDeviceValueByParams = exports.selectDeviceByPdid = exports.selectDeviceById = exports.selectBuildingsLength = exports.selectBuildings = exports.selectAllPwhCByHtgSysValues = exports.selectActiveStructure = exports.selectActiveStepById = exports.selectActivePwhCId = exports.selectActiveDeviceId = exports.selectActiveBuilding = exports.getInfoModal = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _constants = require("../utils/constants");
var _paulCorePackage = require("paul-core-package");
const selectBuildings = _ref => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.data.buildings) || [];
};
exports.selectBuildings = selectBuildings;
const selectBuildingsLength = _ref2 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref2;
  return ((reducers === null || reducers === void 0 ? void 0 : reducers.data.buildings) || []).length;
};
exports.selectBuildingsLength = selectBuildingsLength;
const selectPwhCListLength = _ref3 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref3;
  return Object.keys((reducers === null || reducers === void 0 ? void 0 : reducers.data.allPwhCByHtgSys) || {}).length;
};
exports.selectPwhCListLength = selectPwhCListLength;
const selectActiveStructure = _ref4 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref4;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.data.activeStructure) || {};
};
exports.selectActiveStructure = selectActiveStructure;
const selectActiveBuilding = _ref5 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref5;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.data.activeBuilding) || null;
};
exports.selectActiveBuilding = selectActiveBuilding;
const selectActivePwhCId = _ref6 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref6;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.data.activePwhC) || null;
};
exports.selectActivePwhCId = selectActivePwhCId;
const selectAllPwhCByHtgSysValues = _ref7 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref7;
  return Object.values((reducers === null || reducers === void 0 ? void 0 : reducers.data.allPwhCByHtgSys) || {});
};
exports.selectAllPwhCByHtgSysValues = selectAllPwhCByHtgSysValues;
const selectDevicesById = _ref8 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref8;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.data.devices.byId) || {};
};
exports.selectDevicesById = selectDevicesById;
const selectDevicesDataByPwhC = _ref9 => {
  var _reducers$data$device;
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref9;
  return ((_reducers$data$device = reducers === null || reducers === void 0 ? void 0 : reducers.data.devices.byPwhC) !== null && _reducers$data$device !== void 0 ? _reducers$data$device : []).map(id => reducers === null || reducers === void 0 ? void 0 : reducers.data.devices.byId[id]);
};
exports.selectDevicesDataByPwhC = selectDevicesDataByPwhC;
const selectFilteredIdList = _ref10 => {
  var _reducers$filteredIdL;
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref10;
  return (_reducers$filteredIdL = reducers === null || reducers === void 0 ? void 0 : reducers.filteredIdList) !== null && _reducers$filteredIdL !== void 0 ? _reducers$filteredIdL : [];
};
exports.selectFilteredIdList = selectFilteredIdList;
const selectDeviceByPdid = thingPDIDDevice => _ref11 => {
  var _reducers$data$device2;
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref11;
  return ((_reducers$data$device2 = reducers === null || reducers === void 0 ? void 0 : reducers.data.devices.byId) !== null && _reducers$data$device2 !== void 0 ? _reducers$data$device2 : {})[thingPDIDDevice];
};

/** @todo move to core selectDeviceById */
exports.selectDeviceByPdid = selectDeviceByPdid;
const selectDeviceById = thingPDIDDevice => _ref12 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref12;
  return reducers === null || reducers === void 0 ? void 0 : reducers.data.devices.byId[thingPDIDDevice];
};

/** @todo move to core selectDeviceValuesById */
exports.selectDeviceById = selectDeviceById;
const selectDeviceValuesById = thingPDIDDevice => _ref13 => {
  let {
    [_paulCorePackage.constants.packageKey]: {
      devices
    } = {}
  } = _ref13;
  return (devices === null || devices === void 0 ? void 0 : devices.values.byId[thingPDIDDevice]) || {};
};

/** @todo move to core selectDeviceValueByParams */
exports.selectDeviceValuesById = selectDeviceValuesById;
const selectDeviceValueByParams = (thingPDIDDevice, displayNameId) => _ref14 => {
  var _ref15;
  let {
    [_paulCorePackage.constants.packageKey]: {
      devices
    } = {}
  } = _ref14;
  return (_ref15 = (devices === null || devices === void 0 ? void 0 : devices.values.byId[thingPDIDDevice]) || {}) === null || _ref15 === void 0 ? void 0 : _ref15[displayNameId];
};
exports.selectDeviceValueByParams = selectDeviceValueByParams;
const selectLastFlushing = _ref16 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref16;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.flushing.last) || null;
};
exports.selectLastFlushing = selectLastFlushing;
const selectActiveDeviceId = _ref17 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref17;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.flushing.activeDeviceId) || null;
};
exports.selectActiveDeviceId = selectActiveDeviceId;
const selectActiveStepById = _ref18 => {
  var _reducers$flushing$st;
  let {
    store: {
      [_constants.packageKey]: {
        reducers
      } = {}
    },
    thingPDIDDevice
  } = _ref18;
  return (_reducers$flushing$st = reducers === null || reducers === void 0 ? void 0 : reducers.flushing.stepById[thingPDIDDevice]) !== null && _reducers$flushing$st !== void 0 ? _reducers$flushing$st : {
    step: 0
  };
};
exports.selectActiveStepById = selectActiveStepById;
const getInfoModal = _ref19 => {
  let {
    [_constants.packageKey]: {
      reducers
    } = {}
  } = _ref19;
  return (reducers === null || reducers === void 0 ? void 0 : reducers.infoModal) || [];
};
exports.getInfoModal = getInfoModal;